@let control = $control();

<unity-control-wrapper [control]="control" [description]="$description()" [displayName]="$displayName()" [showHint]="$showHint()">
  <button
    kendoButton
    themeColor="primary"
    type="button"
    [disabled]="control.disabled"
    [svgIcon]="trackChangesEnableIcon"
    (click)="onClick()">
    Open Form Editor
  </button>
</unity-control-wrapper>

@if ($isOpen()) {
  <unity-dialog-survey-creator-shared [control]="control" (closeEvent)="onClose()" />
}
